<template>
  <div v-if="contract?.id" class="container">
    <div class="row d-flex justify-space-between mt-10">
      <div class="col-auto">
        <p>Contrato #{{ contract.id }} </p>
      </div>
      <div class="col-auto">
        <v-btn
          color="primary"
          text
          small
          @click="dialogContractItem"
        >
          <v-icon
            small
            left
          >
            mdi-plus
          </v-icon> Adicionar Item ao contrato
        </v-btn>
      </div>

      <v-simple-table fixed-header>
        <div
          class="mr-5 ml-5"
          style="cursor: pointer;"
        >
          <v-data-table
            :headers="headers"
            :items="contract.contract_items"
            :items-per-page="100"
            :footer-props="{
              'items-per-page-options': [10, 25, 50, 100]
            }"
            loading-text="carregando lista"
            no-data-text="Nenhum contrato encontrado"
            item-key="id"
            @click:row="openEditContractItemDialog($event)"
          >
            <template
              #item.has_textbook="{ item }"
            >
              {{ item.has_textbook ? 'Sim' : 'Não' }}
            </template>
            <template
              #item.has_question_bank="{ item }"
            >
              {{ item.has_question_bank ? 'Sim' : 'Não' }}
            </template>
            <template
              #item.has_activity="{ item }"
            >
              {{ item.has_activity ? 'Sim' : 'Não' }}
            </template>
            <template
              #item.has_media="{ item }"
            >
              {{ item.has_media ? 'Sim' : 'Não' }}
            </template>
          </v-data-table>
        </div>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import EditContractItemDialog from './EditContractItemDialog.vue'
import AddContracItemDialog from './AddContracItemDialog.vue'
import dayjs from '@/dayjs'

export default {
  components: {
  },
  props: {
    contractId: { type: Number, default: null }
  },
  data: () => ({
    tab: 'dados',
    showList: false,
    contract: {},

    headers: [
      {
        text: 'Sistema de Ensino',
        align: 'center',
        value: 'grade.education_stage.education_system.name'
      },
      {
        text: 'Segmento',
        align: 'center',
        value: 'grade.education_stage.name'
      },
      {
        text: 'Curso/ Ano',
        align: 'center',
        value: 'grade.name'
      },
      {
        text: 'Material',
        align: 'center',
        value: 'has_textbook'
      },
      {
        text: 'Questões',
        align: 'center',
        value: 'has_question_bank'
      },
      {
        text: 'Atividades',
        align: 'center',
        value: 'has_activity'
      },
      {
        text: 'Midia',
        align: 'center',
        value: 'has_media'
      }
    ]
  }),
  watch: {
    contractId: {
      handler (newValue) {
        if (newValue) {
          this.getContract(newValue)
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
  },
  methods: {
    async getContract (id) {
      try {
        this.contract = await this.$api.getContract(id)
      } catch (e) {
        this.$store.dispatch('setSnackbar', {
          text: 'Erro ao carregar contrato',
          color: 'red'
        })
      }
    },
    openEditContractItemDialog (item) {
      this.$dialog.custom(EditContractItemDialog).with({ contractItem: item }).show()
        .then(async (contractItem) => {
          if (!contractItem) {
            return
          }
          await this.getContract(this.contract.id)
        })
    },

    dialogContractItem () {
      this.$dialog.custom(AddContracItemDialog).with({ contractId: this.contract.id }).show()
        .then(async (contractItem) => {
          if (!contractItem) {
            await this.getContract(this.contract.id)
          }
          await this.getContract(this.contract.id)
        })
    },
    dayjs
  }
}
</script>
